export class WbMap {
  constructor() {}

  init() {
    return new Promise((resolve, reject) => {
      this.bindListeners();
      resolve();
    });
  }

  bindListeners() {
    const map = document.querySelectorAll('.portrait-map');
    if (map.length) {
      this.mrc_region = 'mrc-de-roussillon';
      this.regions = JSON.parse(document.querySelector('.portrait-map').getAttribute('data-map-locale'));
      this.viewCity(this.regions);
      this.portrait_map_show_region_data(this.mrc_region);
      document.querySelectorAll('.portrait-map svg .city-cover').forEach(el => {
        el.addEventListener('click', e => this.activeCity(e));
        el.addEventListener('mouseover', e => this.hoverCity(e));
        el.addEventListener('mouseout', e => this.outCity(e));
      });
    }
  }

  viewCity(cities) {
    for (const key in cities) {
      console.log('#' + key + '-cover');
      if (document.querySelectorAll('#' + key + '-cover').length > 0) {
        document.getElementById(key + '-name').classList.add('visible');
        document.getElementById(key + '-cover').classList.add('visible');
        document.getElementById(key + '-back').classList.add('visible');
        document.querySelectorAll('.' + key + '-stroke').forEach(el => {
          el.classList.add('visible');
        });
      }
    }
  }

  hoverCity(e) {
    var hovered_cover = e.target;
    var raw_slug = hovered_cover.getAttribute('id');
    var slug = raw_slug.replace('-cover', '');
    var city_back = document.querySelector('#' + slug + '-back');
    city_back.classList.add('hover');
  }

  outCity(e) {
    var hovered_cover = e.target;
    var raw_slug = hovered_cover.getAttribute('id');
    var slug = raw_slug.replace('-cover', '');
    var city_back = document.querySelector('#' + slug + '-back');

    city_back.classList.remove('hover');
  }

  activeCity(e) {
    let hovered_cover = e.target;
    let raw_slug = hovered_cover.getAttribute('id');
    let slug = raw_slug.replace('-cover', '');
    let city_back = document.querySelector('#' + slug + '-back');
    if (city_back.classList.contains('active')) {
      city_back.classList.remove('active');
      Array.from(document.querySelectorAll('.city-back.active')).forEach(el => el.classList.remove('active'));
      this.portrait_map_show_region_data(this.mrc_region);
      return;
    }

    Array.from(document.querySelectorAll('.city-back.active')).forEach(el => el.classList.remove('active'));
    city_back.classList.add('active');

    this.portrait_map_show_region_data(slug);
  }

  /*
   * Shows the data of a region on the portrait map
   */
  portrait_map_show_region_data(slug) {
    if (!this.regions.hasOwnProperty(slug)) {
      return;
    }

    var data = this.regions[slug];

    if (data.link) {
      document.querySelector('.portrait-map-details__title').innerHTML =
        '<a href="' + data.link + '" target="_blank">' + data.name + '</a>';
    } else {
      document.querySelector('.portrait-map-details__title').innerHTML = data.name;
    }

    let dataDetails = data.details;
    let detailsItems = '';

    for (const [key, value] of Object.entries(dataDetails)) {
      detailsItems +=
        '<article class="wb-icon-list-element ' +
        value.iconAlign +
        '" data-scroll-effect="fadeInUp">' +
        '<div class="wb-icon-list-element__icon --color--' +
        value.iconColor +
        '">' +
        value.icon +
        '</div>' +
        '<div class="wb-icon-list-element__content wb-editor">' +
        '<h4 class="wb-icon-list-element__title ' +
        value.iconAlign +
        '">' +
        value.title +
        '</h4>' +
        value.content +
        '</div>';
      if (value.linkUrl) {
        detailsItems +=
          '<a class="link link--base" href="' +
          value.linkUrl +
          '" target="' +
          value.linkTarget +
          '">' +
          value.linkTitle +
          '</a>';
      }
      detailsItems += '</article>';
    }
    let dataButtons = data.buttons;
    let buttonsItems = '';

    if (dataButtons.length) {
      buttonsItems += '<div class="wb-button-group wb-button-group--none">';

      for (const [key, value] of Object.entries(dataButtons)) {
        buttonsItems +=
          '<a class="wb-button wb-button--' +
          value.buttonStyle +
          '" target="' +
          value.buttonTarget +
          '" href="' +
          value.buttonUrl +
          '">';
        buttonsItems += value.buttonTitle;
        buttonsItems += '</a>';
      }
      buttonsItems += '</div>';
    }
    document.querySelector('.portrait-map-details .wb-icon-list').innerHTML =
      '<div class="wb-icon-list__elements wb-icon-list__elements--' +
      data.column +
      '">' +
      detailsItems +
      '</div>' +
      buttonsItems;
  }
}
